module.exports = __webpack_public_path__ + "static/Pierre-Johnsson-b508d926a506ac3fc3b724ae6691bcd6.jpg";